import { Loadable, RecoilLoadable } from 'recoil';


export const request = <P, R>(action: string, data: P): Loadable<R> => {
  return RecoilLoadable.of(
    fetch(
      '/question/api',
      {
        method: 'POST',
        body: JSON.stringify({
          action,
          data
        }),
        headers: {"Content-Type": "application/json"}
      }
    )
      .then(res => res.json().then(payload => ({ok: res.ok, payload})))
      .then(res => {
        if (!res.ok) {
          throw res.payload
        }
        return res.payload
      })
      .catch(e => {
        if ('result' in e && e.result === 'error') {
          throw new Error(e.message);
        } else {
          throw new Error('不明なエラーが起こりました。');
        }
      })
  );
}
